import { FlexDiv } from "src/common/styles/div";
import styled from "styled-components";

export const ImageSelectorContainer = styled(FlexDiv)`
    align-items: start;
    justify-content: start;
`